// extracted by mini-css-extract-plugin
export default {"notes":"Notes_notes__++BAK","fullSize":"Notes_fullSize__uPmvB"};